// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609241315/js/" + chunkId + "." + {"44":"bc44cec7","225":"b1a774e8","481":"b57e54ad","486":"e8ddd8b1","770":"f7388ef7"}[chunkId] + ".0.7315273645281891.chunk.js";
};